import React  from "react";
import { connect } from "react-redux";
import RecruitmentOverviewTabs from "./components/OveriewTab";
import { 
    Users,
    UserPlus,
    TrendingUp,
    CheckCircle,
 } from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";

const RecruitmentOverview = () => {
    
    return (
        <div className="grid grid-cols-1">
            <div className="space-y-6">
                <SummaryHeader
                    title={"Talent Acquisition"}
                    icon={Users}
                    description={"Track candidate progress and build your dream team"}
                    color={"green"}
                >
                    <div className="summary-item-container">
                        <SummaryItem
                            title="Active Candidates"
                            icon={<UserPlus />}
                            display="9"
                        />
                        <SummaryItem
                            title="Avg. Time to Hire"
                            icon={<TrendingUp />}
                            display="28 days" 
                        />
                        <SummaryItem
                            title="Offers Extended"
                            icon={<CheckCircle />}
                            display="1" 
                        />
                    </div>
                </SummaryHeader>
                <RecruitmentOverviewTabs />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(RecruitmentOverview);